module.exports = __webpack_public_path__ + "img/hits.f5a54e40.png";